import { useMemo } from 'react';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import { useForm } from 'react-hook-form-legacy';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import * as yup from 'yup-legacy';
import useYupValidationResolver from '../../../components/form/useYupValidationResolver';

export type TimeEntryNotesFormData = {
  notes: string;
};

type Props = {
  notes: string | null;
  required?: boolean;
};

const fieldName = 'notes';

export const useTimeEntryNotesForm = ({ notes, required = false }: Props) => {
  const { t } = useTranslation();
  const validationSchema = useMemo(() => {
    const base = yup.string().max(32768).ensure().trim();
    return yup.object().shape<TimeEntryNotesFormData>({
      notes: required
        ? base.required(
            t('timeTracking.current.stopTrackingModal.notesRequired'),
          )
        : base,
    });
  }, [required, t]);

  const defaultValues = {
    notes: notes ?? '',
  };
  const form = useForm<TimeEntryNotesFormData>({
    defaultValues,
    validationResolver: useYupValidationResolver(validationSchema),
  });

  return useMemo(
    () => ({
      fieldName,
      form,
    }),
    [form],
  );
};
